import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { serviceConstants } from "src/app/constants/service.constants";

@Injectable({
    providedIn: 'root'
  })
  export class SmtpConfigurationService {
  
    getHeaders(): any {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        withCredentials: true
      };
      return httpOptions;
    }
    jsonOptions: { responseType: 'json' | undefined, withCredentials: boolean | undefined } = { responseType: "json", withCredentials: true };
  
    constructor(private readonly http: HttpClient) { }
  
    insertConfigAsync(model: SmtpConfiguration): Observable<any> {
      return this.http.post(serviceConstants.apiURL + 'api/SMTPConfiguration/InsertSMTPConfiguration', model, this.getHeaders());
    }
  
    fetchConfigAsync(): Observable<SmtpConfiguration> {
      return this.http.get<SmtpConfiguration>(serviceConstants.apiURL + 'api/SMTPConfiguration/Fetch/', this.jsonOptions);
    }
  
    GetSMTPRecordList(): Observable<SmtpConfiguration> {
      return this.http.get<SmtpConfiguration>(serviceConstants.apiURL + 'api/SMTPConfiguration/GetSMTPRecordList/', this.jsonOptions);
    }
  
    FetchRecordByIDAsync(EmailConfigID: string): Observable<SmtpConfiguration> {
      return this.http.get<SmtpConfiguration>(serviceConstants.apiURL + 'api/SMTPConfiguration/FetchRecordByIDAsync/'+ EmailConfigID, this.jsonOptions);
    }
  
    smtpTestAsync(model: SMTPTestModel): Observable<any> {
      return this.http.post<any>(serviceConstants.apiURL + 'api/SMTPConfiguration/SMTPTest', model, this.jsonOptions);
    }

    GraphAPISendTest(model: SMTPTestModel): Observable<any> {
      return this.http.post<any>(serviceConstants.apiURL + 'api/SMTPConfiguration/GraphAPISendTest', model, this.jsonOptions);
    }

    uploadFile(file: File, fileId: string = ''): Observable<FileData> {
      const formData = new FormData();
      formData.append('file', file);
      return this.http.post<FileData>(serviceConstants.apiURL + 'api/SMTPConfiguration/upload/' + (fileId || ''), formData, this.jsonOptions);
    }
  
  }
  export interface FileData {
    FileID?: string;
    FileName?: string;
    FileExt?: string;
    IsFromTemp? : boolean
    FileBytes?: any;
    downloadUrl?: any;
  }
  
  export interface SmtpConfiguration {
    EmailConfigID?: string;
    EmailID?: string;
    EmailPwd?: string;
    EmailDisplayName?: string;
    SMTPHost?: string;
    SMTPPort?: string;
    SMTPSSL?: string;
    UserID?: string;
    EmailAccountTypeCode?: string;
    GSuiteFileID?: string;
    FileName?: string;
    FileExt?: string;
    MicrosoftTenantID?: string;
    MicrosoftClientID?: string;
    MicrosoftClientSecret?: string;
    LoggedUserID?: string;
    EmailServerStatus?:boolean;
  }
  
  export interface ConfigSummary {
    EmailConfigID?: string;
    EmailID?: string;
  }
  
  export interface SMTPTestModel {
    SMTPConfig?: SmtpConfiguration;
    ToEmailID?: string;
    Subject?: string;
    Body?: string;
  }
  export interface EMResponses {
    SuccessMessage?: string;
    errMessage?: string;
    Status?: string;
    errorList?: string[];
    StatusCode?: string;
    Data?: any;
}